import { useViewBearingInnerRing } from './screen/useViewBearingInnerRing';
import { useViewBearingOuterRing } from './screen/useViewBearingOuterRing';
import { useViewBearingRollingElement } from './screen/useViewBearingRollingElement';
import { useViewExciterSpeed } from './screen/useViewExciterSpeed';
import { useViewLateralDisplacement } from './screen/useViewLateralDisplacement';
import { useViewRms } from './screen/useViewRms';
import { useViewStrokeAngle } from './screen/useViewStrokeAngle';
import { useViewStrokeLength } from './screen/useViewStrokeLength';
import { useViewThd } from './screen/useViewThd';
import type { DateRangeParams } from './types';

type Navigator = ((params?: DateRangeParams) => void) | undefined;

export const useSignalTrendNavigation = (
  equipmentId: string | undefined,
  baseSignalName: string | undefined
): Navigator => {
  const id = equipmentId ?? '';
  const viewRms = useViewRms(id);
  const viewExciterSpeed = useViewExciterSpeed(id);
  const viewThd = useViewThd(id);
  const viewLateralDisplacement = useViewLateralDisplacement(id);
  const viewStrokeLength = useViewStrokeLength(id);
  const viewStrokeAngle = useViewStrokeAngle(id);
  const viewBearingInnerRing = useViewBearingInnerRing(id);
  const viewBearingOuterRing = useViewBearingOuterRing(id);
  const viewBearingRollingElement = useViewBearingRollingElement(id);

  if (!baseSignalName) {
    return undefined;
  }

  const map: Record<string, Navigator> = {
    // Screen
    RmsG: viewRms,
    ExciterSpeedRpm: viewExciterSpeed,
    Thd: viewThd,
    ThdR: viewThd,
    StrokeLateralMm: viewLateralDisplacement,
    StrokeMm: viewStrokeLength,
    StrokeAngleDegrees: viewStrokeAngle,
    sBcuIr: viewBearingInnerRing,
    sBcuOr: viewBearingOuterRing,
    sBcuRe: viewBearingRollingElement,
  };

  return map[baseSignalName];
};
